import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Card } from "react-bootstrap";
import {
  MEDIA_TYPES,
  CONSTANTS,
  DATE_FORMATS,
} from "../../constants/app-constant";
import { FEED_DETAILS } from "../../constants/route-constants";
import { formatDate, groupBy } from "../../utility/common-methods";

import "./style.sass";
const { DATA_NOT_FOUND, EMPTY_STRING } = CONSTANTS;

const FeedItem = ({
  client_id,
  article_id,
  edition,
  entity_id,
  entity_name,
  entity_type,
  headline,
  id,
  language,
  publication_type,
  publication,
  website_url,
  publish_date,
  seq,
  isModal,
  similar_articles,
  source,
  summary,
  topicType,
  onFeedSelect,
  checked = false,
  selectedFeeds = [],
  tabKey,
  articleIdList,
  page_no,
  Forclient_id,
  abbreviation,
  source_name,
  link,
  photo,
  page_nos,
  images,
  imagebaseurl,
  article_type,
}) => {
  const [isSelected, setSelected] = useState(checked);

  const news = {
    article_id,
    edition,
    entity_id,
    entity_name,
    entity_type,
    headline,
    language,
    publication,
    publication_type,
    publish_date,
    source,
    summary,
    source_name,
    link,
    photo,
    page_nos,
    images,
    imagebaseurl,
    article_type,
  };

  useEffect(() => {
    setSelected(checked);
  }, [checked]);

  const PRINT = "print";
  const ONLINE = "online";
  const PRESS_RELEASE = "Press Release";

  const feedSelect = (checked, news) => {
    setSelected(checked);
    onFeedSelect && onFeedSelect(checked, news);
  };

  const renderEditions = () => {
    if (topicType == PRINT && tabKey == PRESS_RELEASE) {
      return <>{edition}</>;
    } else if (
      ((topicType == PRINT && tabKey != PRESS_RELEASE) ||
        (topicType == ONLINE && tabKey != PRESS_RELEASE)) &&
      similar_articles &&
      similar_articles.length > 0
    ) {
      let groupedEditions = groupBy(similar_articles, "abbreviation");
      let editions = Object.keys(groupedEditions);
      console.log(editions)
      return editions.map((edition) => {
        return (
          <>
            <span
              className="link"
              onClick={(e) =>
                handleEditionClick(e, { client_id , Forclient_id, article_id, entity_id })
              }
            >
              {edition.trim().toUpperCase() || DATA_NOT_FOUND}
            </span>
            ,&nbsp;
          </>
        );
      });
      // return <>{editions.toString()}</>;
    } else if (topicType == ONLINE) {
      return <>{language}</>;
    } else {
      const tempArr =
        Array.isArray(abbreviation) &&
        abbreviation.map((v) => v.trim().toUpperCase());
      return (
        <span
          className="link"
          onClick={(e) =>
            handleEditionClick(e, { client_id, Forclient_id, article_id, entity_id })
          }
        >
          {(!Array.isArray(abbreviation)
            ? abbreviation === undefined
              ? edition
              : abbreviation.toUpperCase()
            : tempArr.toString()) ||
            edition ||
            "NA"}
        </span>
      );
    }
  };
  const handleEditionClick = (e, data) => {
    e.preventDefault();
    e.stopPropagation();
    let { client_id, Forclient_id, entity_id } = data || {};
    data &&
      window.open(
        `https://${window.location.host}${FEED_DETAILS}/${
          MEDIA_TYPES.PRINT_MV
        }/${client_id == "" ? Forclient_id : client_id }-${data.article_id}-${data.entity_id}`,
        "_blank"
      );
  };
  const handleCardClick = () => {
    localStorage.setItem("articleIdList", JSON.stringify(articleIdList));
    if (topicType == PRINT) {
      window.open(
        `https://${window.location.host}${FEED_DETAILS}/${
          MEDIA_TYPES.PRINT_MV
        }/${client_id || Forclient_id}-${article_id}-${entity_id}`,
        "_blank"
      );
    }
    if (topicType == ONLINE) {
      window.open(
        `https://${window.location.host}${FEED_DETAILS}/${
          MEDIA_TYPES.ONLINE_MV
        }/${client_id || Forclient_id}-${article_id}-${entity_id}`,
        "_blank"
      );
    }
  };

  const renderOnlineModalFeeds = () => {
    return (
      <>
        <ul className="card-entities metaTagsWrap" key={id}>
          <li className="publicationItem">
            <span className="label-span">Website :</span>{" "}
            <span className="link" onClick={() => window.open(website_url)}>
              {publication}
            </span>
          </li>
          <li className="sourceItem">
            <span className="label-span">Source :</span>{" "}
            <span>{source_name}</span>
          </li>
          <li className="entityItem">
            <span className="label-span">Language :</span>{" "}
            <span>{language}</span>
          </li>
          <li className="publicationItem">
            <span className="label-span">Publish Date :</span>{" "}
            <span>{formatDate(publish_date, DATE_FORMATS.DDMMYYYY_dash)}</span>
          </li>
        </ul>
      </>
    );
  };

  const renderPrintModalFeeds = () => {
    return (
      <>
        <ul className="card-entities metaTagsWrap" key={id}>
          <li className="publicationItem">
            <span className="label-span">Publication :</span>{" "}
            <span>{publication}</span>
          </li>
          <li className="sourceItem">
            <span className="label-span">Source :</span>{" "}
            <span>{source_name}</span>
          </li>
          <li className="pageNoItem">
            <span className="label-span">Page No :</span> <span>{page_no}</span>
          </li>
          <li className="publicationItem">
            <span className="label-span">Publish Date :</span>{" "}
            <span>{formatDate(publish_date, DATE_FORMATS.DDMMYYYY_dash)}</span>
          </li>
          <li className="editionItem">
            <span className="label-span">Edition :</span> {renderEditions()}
          </li>
        </ul>
      </>
    );
  };

  const renderPrintFeeds = () => {
    return (
      <>
        <ul className="card-entities metaTagsWrap" key={id}>
          <li className="entityItem">
            <span className="label-span">Entity :</span>{" "}
            <span>{entity_name}</span>
          </li>
          <li className="publicationItem">
            <span className="label-span">Publication :</span>{" "}
            <span>{publication}</span>
          </li>
          <li className="pageNoItem">
            <span className="label-span">Page No :</span> <span>{page_no}</span>
          </li>
          <li className="sourceItem">
            <span className="label-span">Source :</span>{" "}
            <span>{source_name}</span>
          </li>
          <li className="editionItem">
            <span className="label-span">Edition :</span> {renderEditions()}
          </li>
        </ul>
      </>
    );
  };

  const renderOnlineFeeds = () => {
    return (
      <>
        <ul className="card-entities metaTagsWrap" key={id}>
          <li className="entityItem">
            <span className="label-span">Entity :</span>{" "}
            <span>{entity_name}</span>
          </li>
          <li className="publicationItem">
            <span className="label-span">Website :</span>{" "}
            <span className="link" onClick={() => window.open(website_url)}>
              {publication}
            </span>
          </li>
          <li className="sourceItem">
            <span className="label-span">Source :</span>{" "}
            <span>{source_name}</span>
          </li>
          <li className="entityItem">
            <span className="label-span">Language :</span>{" "}
            <span>{language}</span>
          </li>
        </ul>
      </>
    );
  };

  const renderFeeds = () => {
    if (topicType == PRINT && isModal) {
      return renderPrintModalFeeds();
    } else if (topicType == PRINT && !isModal) {
      return renderPrintFeeds();
    } else if (topicType == ONLINE && isModal) {
      return renderOnlineModalFeeds();
    } else if (topicType == ONLINE && !isModal) {
      return renderOnlineFeeds();
    }
  };

  return (
    <>
      {headline && (
        <div className="inner-feed-container">
          <Card
            className={
              topicType == PRINT
                ? "innerFeedItem pageNoAvailable"
                : "innerFeedItem"
            }
            body
          >
            <div className="headlineWrapper">
              <label className="inputWrap">
                <input
                  type="checkbox"
                  className="styled-checkbox"
                  checked={isSelected}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => feedSelect(!isSelected, news)}
                />
                <span className="checkmark"></span>
              </label>
              <label
                className="headlineLabel"
                onClick={() => handleCardClick()}
              >
                {headline}
              </label>
            </div>
            {renderFeeds()}
          </Card>
        </div>
      )}
    </>
  );
};

export default FeedItem;
